import { BoxProps, ButtonProps, ColorOptions } from '@jfs/ui-new'
import { ViewProps } from 'react-native'
import { colors } from '../../util/colors'
import { isTabletWidth } from '../../util/util'

export const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = breakpoint < 600
  // const responsivePadding = getPadding(breakpoint)
  const isTab = isTabletWidth(breakpoint)

  return {
    navbar: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      pt: isMobile ? 24 : isTab ? 20 : 20,
      paddingHorizontal: responsivePadding,
      pb: isMobile ? 24 : isTab ? 20 : 20,
    } as BoxProps,
    nav: {
      display: isMobile ? 'none' : 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      align: 'center',
    } as BoxProps,
    imageLogo: {
      width: 28,
      height: 28,
    },
    navButttons: {
      display: 'flex',
      flexDirection: 'row',
      align: 'center',
      ml: 48,
    } as BoxProps,
    arrowRight: {
      display: isMobile ? 'flex' : 'none',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#FFFFFF29' as ColorOptions,
      borderRadius: 20,
      padding: 8,
      // Todo
      boxShadow: '0px 10px 20px #E0E0E0',
    } as BoxProps,
    navItem: (color: ColorOptions | undefined) =>
      ({
        type: 'tertiary',
        color: 'TRANSPARENT',
        titleColor: color ?? 'WHITE',
        hoverColor: 'TRANSPARENT',
        underlayColor: 'TRANSPARENT',
        textType: 'bodyMedium14',
      } as ButtonProps),
    signup: {
      borderRadius: '40px',
      color: colors.HIGHLIGHT as ColorOptions,
      titleColor: 'WHITE',
      textType: 'bodyMedium12',
      hoverColor: colors.HIGHLIGHT as ColorOptions,
      width: '98px',
      height: '32px',
    } as BoxProps,
    productButton: () =>
      ({
        underlayColor: 'TRANSPARENT',
        h: 32,
        ml: 48,
        justifyContent: 'center',
      } as BoxProps),
    bottomGradient: (isProductButton: boolean) =>
      ({
        height: isProductButton ? 2 : 0,
        backgroundColor: colors.HIGHLIGHT,
        position: 'absolute',
        bottom: 0,
      } as ViewProps),
  }
}
